var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Capa_1",
  enableBackground: "new 0 0 551.13 551.13",
  height: "512px",
  viewBox: "0 0 551.13 551.13",
  width: "512px",
  className: ""
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m275.565 0c-151.944 0-275.565 123.621-275.565 275.565s123.621 275.565 275.565 275.565 275.565-123.621 275.565-275.565-123.621-275.565-275.565-275.565zm0 516.685c-132.955 0-241.119-108.164-241.119-241.119s108.164-241.12 241.119-241.12 241.12 108.164 241.12 241.119-108.165 241.12-241.12 241.12z",
  "data-original": "#000000",
  className: "active-path",
  "data-old_color": "#000000",
  fill: "#1273EB"
}), /*#__PURE__*/React.createElement("path", {
  d: "m137.783 258.342h275.565v34.446h-275.565z",
  "data-original": "#000000",
  className: "active-path",
  "data-old_color": "#000000",
  fill: "#1273EB"
}))));
export default __webpack_public_path__ + "teg/media/minus.97958523.svg";
export { SvgComponent as ReactComponent };